<template>
  <div class="swiper-container">

    <div class="swiper-wrapper">
      <div class="swiper-slide">
        <div class="bj" oncontextmenu="return false;">
          <div class="red-bj">
            <div class="first">
              <img
                class="ani"
                swiper-animate-effect="fadeInRight"
                swiper-animate-duration="1s"
                src="../assets/images/aboutus/about1.png"
                oncontextmenu="return false;"
                alt
              />
            </div>
            <div
              class="firstMsg ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <p>精选整装&nbsp;&nbsp;&nbsp;好而不贵</p>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="brandValue" oncontextmenu="return false;">
          <div class="mask">
            <div style="width:90%;height:60%;margin:13rem auto;">
              <div
                class="brandTitle ani"
                swiper-animate-effect="fadeInLeft"
                swiper-animate-duration="1s"
              >
                <p>桔家云整装</p>
                <p>品牌价值</p>
                <p>Brand value of Ju Jia Yun</p>
              </div>
              <div
                class="brandCont ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
              >
                <ul>
                  <li>由A股上市名企、中国定制家居领军品牌：金牌厨柜全资打造。以厨柜、衣柜、木门等全屋定制产品为核心。</li>
                  <li>全面整合国内外顶尖设计师及一线建材家居品牌产品，为业主提供量房->设计->选材->定制->施工->交付->售后等一站式整体家装服务。</li>
                  <li>金牌厨柜股票代码：603180</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide" style="background:#f2f2f2">
        <div class="brandStrength">
          <div class="strengthOne">
            <div
              class="brandTitle ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <p>桔家云整装</p>
              <p>品牌实力</p>
              <p>Brand strength of Ju Jia Yun</p>
            </div>
            <div
              class="brandImg ani"
              swiper-animate-effect="fadeInDown"
              swiper-animate-duration="1s"
            >
              <span
                class="spans"
                style="font-size:20px;color:#000;float:left;margin-bottom:1rem;font-weight:bolder"
              >雄厚的资金保障</span>
              <div style="display:flex;justify-content: space-between; width:100%;
             ">
                <div style="width:45%;">
                  <img
                    style="width:100%;height:100%"
                    src="../assets/images/aboutus/about3.png"
                    oncontextmenu="return false;"
                    alt
                  />
                </div>
                <div style="width:45%;">
                  <img
                    style="width:100%;height:100%"
                    src="../assets/images/aboutus/about4.png"
                    oncontextmenu="return false;"
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="strengthTwo">
            <div
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="1s"
              style="margin-right:5%;"
            >
              <span
                class="spans"
                style="font-size:20px;color:#000;float:left;margin-bottom:1rem;font-weight:bolder"
              >稳定的量产能力</span>
              <img
                style="width:100%;height:100%"
                oncontextmenu="return false;"
                src="../assets/images/aboutus/about5.png"
                alt
              />
            </div>
            <div class="ani" swiper-animate-effect="fadeInRight" swiper-animate-duration="1s">
              <span
                class="spans"
                style="font-size:20px;color:#000;float:left;margin-bottom:1rem;font-weight:bolder"
              >强大的品牌联盟</span>
              <img
                style="width:120%;height:110%"
                oncontextmenu="return false;"
                src="../assets/images/aboutus/about6.jpeg"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="brandCore">
          <div
            class="brandTitle ani"
            swiper-animate-effect="fadeInLeft"
            swiper-animate-duration="1s"
          >
            <p>桔家云整装</p>
            <p>品牌核心</p>
            <p>Brand core of Ju Jia Yun</p>
          </div>
          <div class="coreOne">
            <img src="../assets/images/smzq/lsyjq.jpg" oncontextmenu="return false;" alt />
            <div
              class="coreOneMsg ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="1s"
            >精选整装&nbsp;&nbsp;&nbsp;&nbsp;好而不贵</div>
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="advanceOne">
          <div
            class="brandTitle ani"
            swiper-animate-effect="fadeInDown"
            swiper-animate-duration="1s"
          >
            <p>桔家云整装</p>
            <p>品牌优势</p>
            <p>Brand Advantage of Ju Jia Yun</p>
          </div>
          <div class="itemMsg ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s">
            <div class="blackred">
              <div style="width: 40%;float: left;text-align: right;">
                <p
                  style="width: 30%;height:30px;line-height:30px;float: right;text-align: center;background: rgb(59, 58, 58);font-weight:bolder;color:#fff"
                >传统装企</p>
              </div>
              <div style="width:140px;height:80px;float:left"></div>
              <div style="width: 40%;float: left;text-align: left;">
                <p
                  style="width: 30%;height:30px;line-height:30px;float: left;text-align: center;background: #b31d25;font-weight:bolder;color:#fff"
                >桔家云整装</p>
              </div>
            </div>
            <div class="contrast" v-for="(item,index) in contrast" :key="index">
              <div class="cLeft">
                <ul>
                  <li>{{item.other1}}</li>
                  <li>{{item.other2}}</li>
                </ul>
              </div>
              <div class="cCenter">
                <p>{{item.title1}}</p>
              </div>
              <div class="cRight">
                <ul>
                  <li>{{item.ju1}}</li>
                  <li>{{item.ju2}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="advanceOne">
          <div
            class="brandTitle ani"
            swiper-animate-effect="fadeInDown"
            swiper-animate-duration="1s"
          >
            <p>桔家云整装</p>
            <p>品牌优势</p>
            <p>Brand Advantage of Ju Jia Yun</p>
          </div>
          <div class="itemTwo">
            <div
              class="flipicon ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <div class="Flip">
                <i class="iconfont icon-qianbi01"></i>
              </div>
              <div style="font-weight:bolder">精选设计</div>
              <div style="line-height:3rem">
                <span
                  style="display: inline-block;width: 10px;height: 10px;background: #fff;border-radius: 50%;"
                ></span> 精选30万设计师，祝您心想室成！
              </div>
            </div>
          </div>
          <div
            class="designpic ani"
            swiper-animate-effect="fadeInRight"
            swiper-animate-duration="1s"
          >
            <img src="../assets/images/aboutus/about11.png" oncontextmenu="return false;" alt />
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="advanceOne one">
          <div class="advantage" style="width:85%;height:85%; margin:5rem auto;position:relative;">
            <div
              class="brandTitle ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <p>桔家云整装</p>
              <p>品牌优势</p>
              <p>Brand Advantage of Ju Jia Yun</p>
            </div>
            <div
              class="flipicons ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <div class="Flips" style="color:#000">
                <i class="iconfont icon-duorenshafa" style="margin-left:-10px;"></i>
              </div>
              <div style="color:#fff;font-weight:bolder">精选产品</div>
              <div style="line-height:3rem;color:#fff;">
                <span
                  style="display: inline-block;width: 10px;height: 10px;background: #fff;border-radius: 50%;"
                ></span> 精选国内外一线家装品牌
              </div>
              <div style="color:#fff;text-indent:15px;">从品牌中再精选优质产品</div>
            </div>
            <div
              class="ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1s"
              style="width:69%;height:85%;right:0rem;bottom:6rem;position:absolute;"
            >
              <img
                style="width:100%;height:100%;"
                oncontextmenu="return false;"
                src="../assets/images/aboutus/about12.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="advanceOne">
          <div class="advantage" style="width:85%;height:85%; margin:5rem auto;position:relative;">
            <div
              class="brandTitle ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <p>桔家云整装</p>
              <p>品牌优势</p>
              <p>Brand Advantage of Ju Jia Yun</p>
            </div>
            <div
              class="flipicons ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <div class="Flips">
                <i class="iconfont icon-youqishua" style="color:#b31d25;margin-left:-10px;"></i>
              </div>
              <div style="color:#b31d25;font-weight:bolder">精选装修</div>
              <div style="line-height:3rem;color:#000;">
                <span
                  style="display: inline-block;width: 10px;height: 10px;background: #000;border-radius: 50%;"
                ></span> 10年以上专业施工队
              </div>
              <div style="color:#000;text-indent:15px;">18年领先行业的特色工艺</div>
              <div style="color:#000;text-indent:15px;line-height:3rem;">168个施工节点严控监理</div>
            </div>
            <div
              class="ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1s"
              style="width:55%;height:85%;right:4rem;bottom:6rem;position:absolute;"
            >
              <img
                style="width:100%;height:100%;"
                oncontextmenu="return false;"
                src="../assets/images/aboutus/about13.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="brandPrivilege">
          <div class="privilegeOne" oncontextmenu="return false;"></div>
          <div class="privilegeTwo">
            <div class="ptop">
              <div
                class="brandTitle ani"
                swiper-animate-effect="fadeInLeft"
                swiper-animate-duration="1s"
              >
                <p>桔家云整装</p>
                <p>品牌特权</p>
                <p>Brand privilege of Ju Jia Yun</p>
              </div>
            </div>
            <div
              class="pbot ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1s"
              style="margin-top:2rem"
            >
              <img src="../assets/images/aboutus/about7.png" oncontextmenu="return false;" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="brandProtection" oncontextmenu="return false;">
          <div class="protectionCenter">
            <div
              class="brandTitle ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <p>桔家云整装</p>
              <p>品牌保障</p>
              <p>Brand protection of Ju Jia Yun</p>
            </div>
            <div
              class="protectionMsg ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1s"
            >
              <div style="width:100%;height:120px;" v-for="(item,index) in protection" :key="index">
                <div class="ptotitle">
                  <p>{{item.title}}</p>
                </div>
                <div class="promsg">
                  <ul>
                    <li>{{item.msg1}}</li>
                    <li>{{item.msg2}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide" style="background: #f2f2f2;">
        <div class="brandAesthetice">
          <div class="AestheticeTop">
            <div
              class="topLeft ani"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <div
                class="brandTitle"
                style="margin-top:2rem;margin-bottom:2rem;height:30%;width:100%"
              >
                <p>桔家云整装</p>
                <p>品牌美学</p>
                <p>Brand Aesthetice of Ju Jia Yun</p>
              </div>
              <div class="leftDetail">
                <ul>
                  <li>
                    2019年9月28日，首家桔家云整装线下精选店，
                    <p>以重新定义家居美学的姿态，</p>
                    <p>在厦门市五缘湾海天广场倾城启幕，</p>
                    <p>迅速成为网红打卡圣地。</p>
                  </li>
                  <li>全新的“线上整合，线下精选”模式。深受业主追捧。</li>
                  <li>
                    1500平整装家具美学馆，内含全厦门最懂生活的实景样板房，
                    <p>为单身、恋爱、新婚、育儿、中年、养老等六大生命周期的业主进行专属设计。</p>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="topRight ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1s"
            >
              <img src="../assets/images/aboutus/about8.png" oncontextmenu="return false;" alt />
            </div>
          </div>
          <div
            class="AestheticeBot ani"
            swiper-animate-effect="fadeInUp"
            swiper-animate-duration="1s"
          >
            <img src="../assets/images/aboutus/about9.png" oncontextmenu="return false;" alt />
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="brandCharisma">
          <div class="charismaTop">
            <div
              class="brandTitle ani"
              style="margin-top:5rem;height:30%;width:25%;margin-left:6%;"
              swiper-animate-effect="fadeInLeft"
              swiper-animate-duration="1s"
            >
              <p>桔家云整装</p>
              <p>品牌魅力</p>
              <p>Brand Charisma of Ju Jia Yun</p>
            </div>
            <div
              class="charismaBot ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1s"
            >
              <img src="../assets/images/aboutus/about10.png" oncontextmenu="return false;" alt />
            </div>
          </div>
          <div class="bottom ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s">
            <BottomFoot></BottomFoot>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>
<script>
import Vue from "vue";
import BottomFoot from "../components/BottomFoot.vue";
import swiper from "swiper";

import * as swiperAni from "../swiper.animate.min.js";
export default {
  components: {
    BottomFoot,
  
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "厦门金牌桔家云整装科技有限公司成立于2018年，总部位于厦门市同安区，由A股上市企业金牌厨柜出品，自主研发的“桔家云整装”信息系统，全面整合国内外优质建材、家具、软装等品牌供应商资源，一键打通设计、订单、生产、物流、仓储、安装、施工监控等泛家装各环节，为全国装企、设计师、施工队等组织赋能，向家装业主提供更全面、更高效、更优质的整体家装解决方案。"
        },
        {
          name: "keywords",
          content:
            "桔家云整装官网，桔家云整装，桔家云，整装，全包，装修，毛坯装修，全屋定制，拎包入住，金牌厨柜，桔家衣柜，桔家木门"
        }
      ]
    };
  },
  data() {
    return {
      nub: "6",
      protection: [
        {
          title: "零缺陷保障",
          msg1: "600万产品、装修质保全，",
          msg2: "保障装修及材料品质安全。"
        },
        {
          title: "零死角保障",
          msg1: "装修及材料安装可视化直播，",
          msg2: "保障装修与材料更透明、更安心。"
        },
        {
          title: "零甲醛保障",
          msg1: "全屋环保治理，消灭甲醛、甲苯等有毒物质，",
          msg2: "保障居住健康。"
        },
        {
          title: "零损失保障",
          msg1: "装修过程全投保，",
          msg2: "保障家庭财产不损失。"
        },
        {
          title: "零增项保障",
          msg1: "签订闭口合同，",
          msg2: "保障零增项。"
        }
      ],
      contrast: [
        {
          other1: "传统装企经常出现工期延误、",
          other2: "大量返工等现象！",
          title1: "时间成本",
          ju1: "一站式搞定设计、产品、施工等家装各环节",
          ju2: "环环相扣，效率大增。"
        },
        {
          other1: "全无自有产品，价格毫无优势，装修过程增项不断，",
          other2: "最终花费通常是预算的150%！",
          title1: "费用成本",
          ju1: "自有全屋定制产品+所联合一线品牌均为工厂直供，",
          ju2: "签订闭合价合同，为您实现预算=决算。"
        },
        {
          other1: "工人技术无法保障，一不留神就通工减料，",
          other2: "不得不花费大量精力跟进施工！",
          title1: "精力成本",
          ju1: "一线品牌全直供，无忧选材不费劲；",
          ju2: "装修过程全直播，品质筑家有保障。"
        },
        {
          other1: "库存产品，杂牌冒牌居多，",
          other2: "以次充好！",
          title1: "质量保障",
          ju1: "上市品牌，",
          ju2: "值得信赖。"
        },
        {
          other1: "虚假承诺，滥竽充数",
          other2: "装修效果和设计效果明显不符！",
          title1: "装修效果",
          ju1: "风格统一，完全按照您的需求定制，",
          ju2: "实现所见即所得的装修效果。"
        },
        {
          other1: "出现问题，",
          other2: "最擅长各种推诿！",
          title1: "售后服务",
          title2: "",
          ju1: "600万先行赔付，",
          ju2: "为您的爱家保驾护航。"
        }
      ]
    };
  },
  mounted() {
    let self = this;
    new swiper(".swiper-container", {
      direction: "vertical",
      slidesPerView: 1,
      spaceBetween: 30,
      mousewheel: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      on: {
        init: function() {
          swiperAni.swiperAnimateCache(this);
          swiperAni.swiperAnimate(this);
        },
        slideChange: function() {
          swiperAni.swiperAnimate(this);
        }
      }
    });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {}
};
</script>

<style scoped>
html,
body {
  position: relative !important;
  height: 100% !important;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
}
.Flip {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  width: 98px;
  height: 58px;
  margin-left: 10px;
}
.iconfont {
  font-size: 90px;
  color: #fff;
}
.flipicon {
  width: 23%;
  height: 120px;
  position: absolute;
  text-align: left;
  left: 17%;
  top: 25%;
}
.flipicons {
  width: 290px;
  height: 120px;
  position: absolute;
  text-align: left;
  bottom: 18rem;
}
.one {
  background: #b31d25;
}
.one div .brandTitle p {
  color: #fff;
}
.designpic {
  position: absolute;
  width: 43.3%;
  right: 10%;
  bottom: 11%;
}
.swiper-container {
  position: absolute;     
  width: 100%;
  height: 99.2%;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.bj {   
  position: absolute;
  width: 100%;
  height: 100%;
  background: url("../assets/images/smzq/dazkj.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
}
.firstMsg p {
  color: #fff;
  font-size: 35px;
  line-height: 3rem;
}
.first {
  width: 290px;
  height: 190px;
  margin: 0 auto;
}
.first img,
.coreOne img,
.pbot img,
.AestheticeBot img,
.AestheticeTop > div img,
.charismaBot img,
.designpic img {
  width: 100%;
  height: 100%;
}
.red-bj {
  width: 100%;
  height: 300px;
  background: #b31d25;
}
.brandValue {
  position: relative;
  width: 100%;
  height: 910px;
  margin-top: 2rem;
  background: url("../assets/images/aboutus/about2.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.mask .brandTitle {
  width: 90%;
  margin: 0 auto;
  margin-top: 3rem;
}
.brandTitle p:first-child,
.brandTitle p:last-child {
  color: #000;
  font-size: 30px;
  font-weight: bolder;
  text-align: left;
  margin: 0 0;
}
.brandTitle p:last-child {
  font-size: 25px;
}
.brandTitle p:nth-child(2) {
  color: #000;
  font-size: 50px;
  margin: 0 0;
  font-weight: bolder;
  text-align: left;
}
.mask {
  position: absolute;
  width: 700px;
  height: 90%;
  background: rgba(255, 255, 255, 0.637);
  bottom: 0;
  left: 100px;
}
.brandCont {
  text-align: left;
}
.brandCont ul {
  font-size: 16px;
  color: #000;
  line-height: 2.5rem;
  font-weight: bolder;
  list-style: none;
}
.brandCont ul li:before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #000;
  border-radius: 50%;
  margin-right: 10px;
}
.brandStrength,
.brandCore,
.carousel,
.brandPrivilege,
.brandProtection,
.brandCharisma {
  width: 100%;
  height: 100%;
}
.advanceOne {
  margin-top: 6rem;
  width: 90%;
  height: 100%;
}
.advanceOne .brandTitle {
  width: 30%;
  margin-top: 8rem;
}
.itemMsg {
  width: 100%;
  margin: 0 auto;
  margin-top: -8rem;
}
.itemMsg ul {
  list-style: none;
}
.contrast {
  width: 70%;
  height: 105px;
  margin-left: 20%;
}
.blackred {
  width: 70%;
  height: 80px;
  margin-left: 20%;
}
.cLeft,
.cCenter,
.cRight {
  float: left;
}
.cLeft {
  width: 40%;
  color: #575757;
  border-right: 2px dotted #898989;
}
.cLeft ul {
  text-align: right;
  padding-right: 20px;
}
.cRight {
  width: 40%;
  color: #575757;
  border-left: 2px dotted #898989;
}
.cRight ul {
  text-align: left;
  padding-left: 20px;
}
.cCenter {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #898989;
  font-size: 20px;
  color: #fff;
  font-weight: bolder;
  margin: 0 30px;
}
.cCenter p {
  margin: 15px 20px;
}
.itemTwo {
  width: 100%;
  height: 35%;
  color: #fff;
  margin-top: 8.5rem;
  background: #b31d25;
  position: relative;
}
.strengthOne,
.strengthTwo {
  width: 85%;
  height: 50%;
  margin: 0 auto;
}
.strengthOne .brandTitle {
  width: 46%;
  float: left;
  margin-top: 12rem;
}
.strengthOne .brandImg {
  width: 54%;
  float: left;
  margin-top: 8.5rem;
}
.spans:before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #000;
  border-radius: 50%;
  margin-right: 10px;
}
.strengthTwo > div {
  width: 41%;
  height: 70%;
  float: left;
}
.brandCore .brandTitle {
  width: 85%;
  height: 18%;
  margin: 0 auto;
  margin-top: 8rem;
}
.coreOne {
  position: relative;
  width: 79%;
  height: 63%;
  float: left;
}
.coreOneMsg {
  position: absolute;
  width: 50%;
  height: 180px;
  background: #b80a13ad;
  left: 0;
  bottom: 34%;
  line-height: 180px;
  color: #fff;
  font-size: 35px;
}
.el-carousel {
  margin-top: 4rem;
  border: 1px solid #000;
}
.privilegeOne {
  position: relative;
  width: 100%;
  height: 50%;
  margin-top: 118px;
  background: url("../assets/images/smzq/tygsj.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.privilegeTwo {
  position: absolute;
  top: 36.9%;
  width: 80%;
  height: 60%;
  left: 10%;
}
.ptop {
  width: 100%;
  height: 45%;
  background: #b31d25;
}
.ptop .brandTitle {
  position: absolute;
  top: 10%;
  left: 12%;
}
.pbot {
  height: 45%;
  width: 100%;
}
.brandProtection {
  position: relative;
  width: 100%;
  margin-top: 5.9rem;
  height: 88%;
  background: url("../assets/images/smzq/rsdys.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.brandProtection .brandTitle p,
.brandCharisma .charismaTop .brandTitle p,
.privilegeTwo .ptop .brandTitle p {
  color: #fff;
}
.protectionCenter {
  width: 60%;
  height: 80%;
  margin: 0 auto;
  margin-top: 7rem;
}
.protectionCenter .brandTitle {
  width: 40%;
  float: left;
}
.protectionMsg {
  width: 50%;
  height: 100%;
  float: right;
}
.ptotitle {
  float: left;
  width: 100px;
  height: 100px;
  font-size: 28px;
  border-radius: 50%;
  background: #db101a79;
}
.ptotitle p {
  margin: 17px 0px;
  font-weight: bolder;
  color: #fff;
}
.promsg {
  float: right;
  width: 70%;
  border-left: 2px dotted #fff;
  color: #fff;
}
.promsg ul {
  text-align: left;
  list-style: none;
  padding-left: 2rem;
}
.brandAesthetice {
  width: 80%;
  height: 100%;
  margin: 0 auto;
}
.AestheticeTop {
  margin-top: 118px;
  width: 100%;
  height: 47%;
}
.topLeft {
  width: 55%;
  float: left;
}
.topRight {
  width: 45%;
  height: 100%;
  float: left;
}
.AestheticeBot {
  width: 100%;
}
.leftDetail {
  height: 70%;
  width: 100%;
}
.leftDetail ul {
  list-style: none;
  text-align: left;
  color: #000;
  padding-left: 0;
  font-weight: bolder;
}
.leftDetail ul li:before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #000;
  border-radius: 50%;
  margin-right: 10px;
}
.leftDetail ul li p {
  margin: 10px 26px;
}
.leftDetail ul li:nth-child(2) {
  margin: 10px 0;
}
.charismaTop {
  width: 100%;
  height: 35%;
  margin-top: 11%;
  background: #b31d25;
}
.brandCharisma .charismaTop .brandTitle {
  float: left;
}
.charismaBot {
  float: left;
  width: 65%;
  height: 100%;
}
.bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>
